var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#DCFDDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7775 29.3387L38.7775 29.3388L38.7843 29.3318C39.3813 28.7141 39.391 27.7308 38.7775 27.1172C38.1677 26.5074 37.1658 26.5074 36.556 27.1172L30.1067 33.5665L27.4441 30.9039C26.8343 30.2941 25.8325 30.2941 25.2227 30.9039C24.6129 31.5137 24.6129 32.5155 25.2227 33.1254L28.996 36.8987C29.2886 37.1913 29.6868 37.3594 30.1067 37.3594C30.5267 37.3594 30.9249 37.1913 31.2175 36.8987L38.7775 29.3387ZM19.2382 32.0013C19.2382 24.9702 24.969 19.2394 32.0001 19.2394C39.0312 19.2394 44.762 24.9702 44.762 32.0013C44.762 39.0324 39.0312 44.7632 32.0001 44.7632C24.969 44.7632 19.2382 39.0324 19.2382 32.0013Z",
    fill: "#11A811",
    stroke: "#11A811",
    strokeWidth: 1.14286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.3a8342e87fe5dc1d21c6752b34885e10.svg";
export { ForwardRef as ReactComponent };